import IDMGlobals from '../IDMGlobals';
import IDMUtils from '../IDMUtils';
//
const CookieWrap = require('js-cookie');
/**
 *
 */
export default class _CookiesLocal {

  /**
   * constructor - description
   *
   * @return {type}  description
   */
  constructor() { this.cookieEngine = CookieWrap; }

  /**
   * cleanKey - description
   *
   * @param  string | string[] key description
   * @return {type}     description
   */
  async cleanKey(key) { 
    return new Promise(async (resolve) => {
      if (Array.isArray(key)) for (let a of key) this.cookieEngine.remove(a, { domain: this.__getRootDomain() });
      else this.cookieEngine.remove(key, { domain: this.__getRootDomain() });
      resolve();
    });
  }

  /**
   * getValue - description
   *
   * @param  {type} key description
   * @return {type}     description
   */
  async getValue(key) { 
    return new Promise(async (resolve) => {
      resolve(this.cookieEngine.get(key));
    });
  }

  /**
   * setDefaultValue - description
   *
   * @param  {type} key description
   * @param  {type} val description
   * @return {type}     description
   */
  async setDefaultValue(key, val) {
    return await this.setValue(key, val, IDMGlobals.CookiesDefaultExpirationPeriod)
  }

  /**
   * setLongLiveValue - description
   *
   * @param  {type} key description
   * @param  {type} val description
   * @return {type}     description
   */
  async setLongLiveValue(key, val) {
    return await this.setValue(key, val, IDMGlobals.CookiesLongLiveExpirationPeriod)
  }

  /**
   * setValue - description
   *
   * @param  {type} key  description
   * @param  {type} val  description
   * @param  {type} ttl description
   * @return {type}      description
   */
  async setValue(key, val, ttl) {
    return new Promise(async (resolve) => {
      this.cookieEngine.set(key, val, {
        secure: IDMGlobals.CookiesSecureStorage,
        domain: this.__getRootDomain(),
        ...(ttl != undefined ? { expires: (new Date(Date.now() + ttl)) } : {}),
        samesite: 'none'
      });
      resolve();
    });
  }

  __getRootDomain() {
    if (IDMUtils.isNodeJS()) return '';
    //
    let d = window.location.host.split(':').shift().split('.');
    if (d.length <= 1) return 'localhost'; //assume localhost
    else {
      while (d.length > 2) d.shift();
      return d.join('.');
    }
  }
}
